import React, { useEffect } from 'react';
import './index.scss';

const ThreePlayPlugin = ({
  target,
  videoId,
  threePlayVideoId,
  onLoad,
  onError,
}) => {
  const scriptTarget = `3p-plugin-target-${threePlayVideoId}-id`;

  useEffect(() => {
    if (!threePlayVideoId || !videoId || !scriptTarget) {
      return;
    }

    const timeoutId = setTimeout(() => {
      onError();
    }, 2000);

    const script = document.createElement('script');
    script.onload = () => {
      clearTimeout(timeoutId);
      onLoad();
    };

    script.src =
      `//plugin.3playmedia.com/ajax.js?mf=${threePlayVideoId}` +
      `&height=37px` +
      `&p3sdk_version=1.10.7` +
      `&p=43165` +
      `&pt=1140` +
      `&target=${scriptTarget}` +
      `&vembed=0` +
      `&video_id=${videoId}` +
      `&video_target=${target}`;
    script.async = true;

    document.body.appendChild(script);

    return () => {
      clearTimeout(timeoutId);
      document.body.removeChild(script);
    };
  }, [threePlayVideoId, videoId, scriptTarget]);

  return <div id={scriptTarget} className="p3sdk-target"></div>;
};

export default ThreePlayPlugin;
